import React, { useContext, useEffect, useState } from "react";
import { IMAGES } from "../../../assets";
import ReviewCard from "../../../components/ReviewCard";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import ProgressBar from "../../../components/ProgressBar";
import { SHOW_TOAST, STRINGS } from "../../../constants";
import moment from "moment";
import { AuthContext } from "../../../context";
import { EbookInfo, addReview } from "../../../api/user";
import * as Yup from "yup";
import PropTypes from "prop-types";

const Reviews = ({ data }) => {
  Reviews.propTypes = { data: PropTypes.node };
  const { t } = useTranslation();
  const { user, activeLanguage } = useContext(AuthContext);
  const [selectedRating, setSelectedRating] = useState("");
  const [bookReviewList, setBookReviewList] = useState(data);
  const onSubmit = (values, { resetForm }) => {
    if (selectedRating) {
      postReview(selectedRating, values?.comment, resetForm);
    } else {
      SHOW_TOAST(t(STRINGS?.plese_enter_ratings), "warning");
    }
  };
  useEffect(() => {}, [bookReviewList, data]);

  const validationSchema = Yup.object({
    comment: Yup.string().required(t(STRINGS?.please_enter_description)),
  });

  async function postReview(rateCount, expereienceInput, resetForm) {
    if (!expereienceInput) {
      SHOW_TOAST(t(STRINGS.review_description));
      return;
    }

    try {
      const params = {
        bookId: data?._id,
        rating: rateCount,
        review: expereienceInput,
        userId: user?.userInfo?._id,
      };

      const result = await addReview(params);

      if (result?.status) {
        let newReivews = await EbookInfo(data?._id);
        setBookReviewList(newReivews?.data?.body[0]);

        data.reviewUserCount = data.reviewUserCount + 1;
        setSelectedRating(0);
        resetForm();
      } else if (
        result?.data?.message === "This user already post review on this book."
      ) {
        SHOW_TOAST(t(STRINGS.sorry_you_can_only), "warning");
      } else {
        SHOW_TOAST(result?.error, "error");
        resetForm();
        setSelectedRating(null);
      }
    } catch (err) {
      console.error(err);
    }
  }

  return (
    <div className="my-2">
      <div className="grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 grid-cols-1 gap-2">
        <div className="bg-white border p-3 rounded-md">
          <h2 className="text-lg font-medium">{t(STRINGS?.rate_this_book)}</h2>
          <p className="text-sm font-normal">
            {t(STRINGS?.tell_other_you_think)}
          </p>
          <div className="flex gap-1">
            {[1, 2, 3, 4, 5].map((index) => (
              <button key={index} onClick={() => setSelectedRating(index)}>
                <img
                  alt="stars"
                  key={index}
                  className="w-auto h-8 "
                  src={
                    index <= selectedRating
                      ? IMAGES?.starIcon
                      : IMAGES?.starOrangeIcon
                  }
                />
              </button>
            ))}
          </div>

          <Formik
            initialValues={{ comment: "" }}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ resetForm }) => {
              return (
                <Form className="">
                  <div className="flex flex-col ">
                    <label className="text-base font-medium">
                      {t(STRINGS?.review_description)}
                    </label>
                    <Field
                      type="text"
                      id="comment"
                      name="comment"
                      placeholder={t(STRINGS?.describe_experience)}
                      className="w-full px-2 py-2 rounded-[8px] text-sm font-normal bg-[#EDE7F557] outline-none"
                    />
                    <ErrorMessage
                      name="comment"
                      component="div"
                      className="text-sm text-red-500 formik-error"
                    />
                    <div className="flex items-end justify-end">
                      <button
                        type="submit"
                        className="px-4 py-1 border rounded-2xl bg-[#480D9B] text-white mt-2"
                      >
                        {t(STRINGS.post)}
                      </button>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>

        <div className="">
          {bookReviewList?.ratings?.length > 0 ? (
            <div className="flex">
              <div className="flex flex-col w-full">
                {activeLanguage === "Marathi" ? (
                  <h2 className="text-4xl font-normal">
                    {new Intl.NumberFormat("mr", {
                      maximumSignificantDigits: 2,
                    }).format(
                      ((5 * bookReviewList?.overallRating) / 100).toFixed(0)
                    )}
                  </h2>
                ) : (
                  <>
                    {activeLanguage === "Marathi" ? (
                      <h2 className="text-4xl font-normal">
                        {new Intl.NumberFormat("mr", {
                          maximumSignificantDigits: 2,
                        }).format(
                          ((5 * bookReviewList?.overallRating) / 100).toFixed(0)
                        )}{" "}
                      </h2>
                    ) : (
                      <h2 className="text-4xl font-normal">
                        {((5 * bookReviewList?.overallRating) / 100).toFixed(0)}
                      </h2>
                    )}
                  </>
                )}

                <div className="flex items-center gap-1">
                  {Array.from({ length: 5 }).map((_, index) => (
                    <img
                      alt="starIcons"
                      key={bookReviewList?.overallRating}
                      className="h-4 w-auto"
                      src={
                        index <
                        Math.round((5 * bookReviewList?.overallRating) / 100)
                          ? IMAGES?.starIcon
                          : IMAGES?.starOrangeIcon
                      }
                    />
                  ))}
                </div>

                <span className="text-sm font-normal text-[#8A8A8A]">
                  {activeLanguage === "Marathi"
                    ? new Intl.NumberFormat("mr", {
                        maximumSignificantDigits: 2,
                      }).format(bookReviewList?.reviewUserCount)
                    : bookReviewList?.reviewUserCount}
                </span>
              </div>

              <div className="w-full">
                <div className="flex items-center justify-center gap-1 ">
                  <p className="text-sm">
                    {activeLanguage === "Marathi"
                      ? new Intl.NumberFormat("mr", {
                          maximumSignificantDigits: 2,
                        }).format(5)
                      : 5}
                  </p>
                  <ProgressBar
                    percentage={bookReviewList?.ratings?.[4]?.percentage}
                    height="6px"
                    color="#FE6B01"
                  />
                </div>
                <div className="flex items-center justify-center gap-1 ">
                  <p className="text-sm">
                    {activeLanguage === "Marathi"
                      ? new Intl.NumberFormat("mr", {
                          maximumSignificantDigits: 2,
                        }).format(4)
                      : 4}
                  </p>
                  <ProgressBar
                    percentage={bookReviewList?.ratings?.[3]?.percentage}
                    height="6px"
                    color="#FE6B01"
                  />
                </div>
                <div className="flex items-center justify-center gap-1 ">
                  <p className="text-sm">
                    {activeLanguage === "Marathi"
                      ? new Intl.NumberFormat("mr", {
                          maximumSignificantDigits: 2,
                        }).format(3)
                      : 3}
                  </p>
                  <ProgressBar
                    percentage={bookReviewList?.ratings?.[2]?.percentage}
                    height="6px"
                    color="#FE6B01"
                  />
                </div>
                <div className="flex items-center justify-center gap-1 ">
                  <p className="text-sm">
                    {activeLanguage === "Marathi"
                      ? new Intl.NumberFormat("mr", {
                          maximumSignificantDigits: 2,
                        }).format(2)
                      : 2}
                  </p>
                  <ProgressBar
                    percentage={bookReviewList?.ratings?.[1]?.percentage}
                    height="6px"
                    color="#FE6B01"
                  />
                </div>
                <div className="flex items-center justify-center gap-1 ">
                  {activeLanguage === "Marathi"
                    ? new Intl.NumberFormat("mr", {
                        maximumSignificantDigits: 2,
                      }).format(1)
                    : 1}
                  <ProgressBar
                    percentage={bookReviewList?.ratings?.[0]?.percentage}
                    height="6px"
                    color="#FE6B01"
                  />
                </div>
              </div>
            </div>
          ) : (
            <p>{t(STRINGS?.no_rating_available)}</p>
          )}
          <div className=" max-h-60 overflow-y-scroll mt-2">
            {bookReviewList?.reviews?.length > 0 &&
              bookReviewList?.reviews?.map((item) => {
                return (
                  <div key={item?._id}>
                    <ReviewCard
                      date={moment(item?.created_at.split("T")[0]).format(
                        "DD-MM-yyyy"
                      )}
                      ratings={item?.rating}
                      name={item?.userName}
                      profile={item?.userImage ?? IMAGES?.userIcon}
                      comment={item?.review}
                    />
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reviews;
